import DotaLogo from "../img/dota-logo-inferno.jpg";
import "./SplashView.css";
function SplashView() {
  return <img className="splash-view" src={DotaLogo} alt="Dota Logo" />;
}

export default SplashView;
